import _ from 'lodash';
import { IntentLabelConfig } from '../../configs/index';
import { updateCaseIndexInOperand, updateCaseIndexInSignals } from 'modules/QuantConfig/signals';

const getSanitizedIntents = (intents, intentIdsMappedNewIds, newCaseIndex) =>
  intents.map(intent => {
    const newIntent = _.cloneDeep(intent);
    newIntent.identifier.caseIndex = newCaseIndex;

    if (!_.isEmpty(newIntent.target)) {
      newIntent.target.caseIndex = newCaseIndex;
    }

    if (newIntent.instrument?.type === 'capture') {
      newIntent.instrument.when = updateCaseIndexInSignals(newIntent.instrument.when, newCaseIndex);
    }

    if (newIntent.instrument?.strike?.type === 'IndicatorValueBasedStrikeIndex') {
      newIntent.instrument.strike.valuePath = updateCaseIndexInOperand(
        newIntent.instrument.strike.valuePath,
        newCaseIndex
      );
    }

    if (intentIdsMappedNewIds[intent.identifier.label]) {
      newIntent.identifier.label = intentIdsMappedNewIds[intent.identifier.label];
    }

    return newIntent;
  });

const getMaxLatestIdForCase = kase => {
  const allIntents = [
    ...(kase?.entry?.intents || []),
    ...(kase?.adjustments || []).flatMap(adj => adj.intents || [])
  ];
  return _.max(allIntents.map(intent => Number(intent.identifier.label)));
};

export const getClonedCase = (cases, idx) => {
  const cloneCase = _.cloneDeep(cases[idx]);
  const newCaseIndex = cases.length;

  cloneCase.entry.intents = getSanitizedIntents(cloneCase.entry.intents, {}, newCaseIndex);
  cloneCase.entry.signal = updateCaseIndexInSignals(cloneCase.entry.signal, newCaseIndex, idx);
  cloneCase.exitSignal = updateCaseIndexInSignals(cloneCase.exitSignal, newCaseIndex, idx);

  cloneCase.adjustments = cloneCase.adjustments.map(adjustment => ({
    ..._.cloneDeep(adjustment),
    signal: updateCaseIndexInSignals(adjustment.signal, newCaseIndex, idx),
    intents: getSanitizedIntents(adjustment.intents, {}, newCaseIndex)
  }));

  IntentLabelConfig.setConfigNameAndValue(newCaseIndex, getMaxLatestIdForCase(cloneCase));

  return cloneCase;
};
